import { cn } from '@/lib/utils/cn';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'destructive' | 'gold';

interface StatusDotProps {
    tone: StatusTone;
    label?: string;
    className?: string;
}

const TONE_CLASS: Record<StatusTone, string> = {
    neutral: 'bg-muted-foreground',
    info: 'bg-info',
    success: 'bg-emerald',
    warning: 'bg-warning',
    destructive: 'bg-destructive',
    gold: 'bg-gold',
};

/**
 * Status dot + optional label. Replaces shadcn pill-style badges for status indication.
 * Pattern Linear : couleur sur le dot, texte gris pour ne pas saturer.
 */
export function StatusDot({ tone, label, className }: StatusDotProps) {
    return (
        <span className={cn('inline-flex items-center gap-2', className)}>
            <span aria-hidden className={cn('h-1.5 w-1.5 rounded-full', TONE_CLASS[tone])} />
            {label && (
                <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                    {label}
                </span>
            )}
        </span>
    );
}
